<template>
  <button
    type="button"
    class="btn screener-btn"
    :class="{ 'btn-outline-info': !filled, 'btn-info': filled }"
    @click.prevent="$emit('click')"
  >
    <slot></slot>
    {{ ' ' }}<span v-if="isNew" class="badge badge-success">New</span>
  </button>
</template>

<script>
export default {
  props: {
    filled: Boolean,
    isNew: Boolean,
  },
}
</script>

<style lang="scss">
.btn-outline-info {
  color: #00a6cb !important;
  border-color: #00a6cb !important;
  background-color: transparent !important;

  // &:focus {
  //   color: #00a6cb;
  //   border-color: #00a6cb !important;
  //   background-color: transparent;
  // }

  // &:hover {
  //   background-color: initial;
  // }

  // @media (hover: hover) {
  //   &:hover{
  //     border-color: #00a6cb !important;
  //     background-color: #00a6cb !important;
  //     color: white;
  //   }
  // }
}
.btn-info {
  border-color: #00a6cb !important;
  background-color: #00a6cb !important;
  color: #fff !important;

  // &:focus {
  //   color: #00a6cb;
  //   border-color: #00a6cb !important;
  //   background-color: #00a6cb;
  // }

  // &:hover {
  //   background-color: initial;
  // }

  // @media (hover: hover) {
  //   &:hover{
  //     border-color: #00a6cb !important;
  //     background-color: #00a6cb !important;
  //     color: white;
  //   }
  // }
}
.screener-btn {
  line-height: 1.5rem;
  padding: 4px 8px;
  margin: 0 1.25rem 0 0;
}
</style>
